module.exports = __webpack_public_path__ + "img/Officebuilding.01289d78.svg";